import { ShippingMethod } from "@/apps/shared/proposal/core/domain/model/ShippingMethod";
import { PaymentMethod } from "@/apps/shared/proposal/core/domain/model/PaymentMethod";
import { Bonus } from "@/apps/shared/buyback/core/domain/model/bonus/bonus";

export function getTotalPriceAsDecimal(
  estimatedPrice: number,
  paymentMethod: PaymentMethod | null = null,
  shippingMethod: ShippingMethod | null = null,
  bonus: Bonus | null = null
): number {
  return (
    estimatedPrice +
    getModifiersAmountAsDecimal(estimatedPrice, paymentMethod, shippingMethod) +
    getBonusAmountAsDecimal(bonus)
  );
}

export function getModifiersAmountAsDecimal(
  estimatedPrice: number,
  paymentMethod: PaymentMethod | null = null,
  shippingMethod: ShippingMethod | null = null
): number {
  let modifierAmountAsDecimal = 0;

  if (paymentMethod?.modifier) {
    modifierAmountAsDecimal += paymentMethod.modifier.getComputedValue(estimatedPrice);
  }

  if (shippingMethod?.modifier) {
    modifierAmountAsDecimal += shippingMethod.modifier.getComputedValue(estimatedPrice);
  }

  return modifierAmountAsDecimal;
}

function getBonusAmountAsDecimal(bonus: Bonus | null): number {
  return bonus === null ? 0 : bonus.amountInCents / 100;
}
